<template>
  <div>
    <!-- 右下标题开始-->
    <div
      id="itemd0cac130-3e05-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
        top:'30px'
      }"
      class="centertitle"
    >
    <p>简历投递情况</p>
    </div>
    <!-- 右下echarts结束-->
    <div id="item93b724c0-3e03-11ec-a2e6-953464dcce14">
    <table rules="none" class="projectNumTable">
        <thead>
          <tr>
            <th>序号</th>
            <th>企业名称</th>
            <th>投递数量</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in showData" :key="item.no">
            <td>{{ item.id }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.total_deliveries }}</td>
          </tr>
        </tbody>
      </table>
      <div style="height: 500px;">4</div>
      </div>
    <!-- 右下背景图开始-->
    <div id="item71b4b580-3deb-11ec-a2e6-953464dcce14">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
    <div id="item71b4b580-3deb-11ec-a2e6-953464dcce14"></div>
    <!-- 右下背景图结束-->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios';
import { baseURL } from '../../../api/base';
export default {
  mounted () {
    this.dealWithData()
  },
  data () {
    return {
      data1: [2.0, 4.9, 7.0, 23.2, 25.6],
      data2: [2.6, 5.9, 9.0, 26.4, 28.7],
      data3: [2.6, 5.9, 9.0, 26.4, 28.7],
      data4: [2.0, 2.2, 3.3, 4.5, 6.3],
      // 模拟数据
      resData: [],
      showData: [
        {
          id:'加载中',
          title:'加载中',
          total_deliveries:'加载中'
        }
      ] // 用于展示的数据
    }
  },
  methods: {
    dealWithData () {
      axios.get(baseURL+'/api/getright3').then(response => {
        this.showData=[]
        response.data.forEach((item, index) => {
        this.showData.push(item)
      })
    })
  },
    /*
      banner滚动
      @param n: 当前展示的第几张图，从0开始
      @param bufferMove: 函数(能够实现元素的减速运动)
    */
    // changeBanner (n, bufferMove) {
    //   const bannerWrap = document.querySelector('#leftBottomShowWindow3 .innerBox')
    //   if (n === -1) {
    //     bannerWrap.style.left = '-1000px'
    //     n = 1
    //   }
    //   bufferMove(
    //     bannerWrap,
    //     {
    //       left: -n * 500
    //     },
    //     30
    //   )
    // }
  }
}
</script>

<style scoped>
#item71b4b580-3deb-11ec-a2e6-953464dcce14 {
  left: 20px;
  top:0px;
  width: 530px;
  height: 950px;
}
/* 标题位置 */
#item9c61daa0-3e05-11ec-a2e6-953464dcce14 {
  top: 14px;
}
#leftBottomShowWindow3 {
  position: absolute;
  left: 35px;
  top: 60px;
  width: 500px;
  height: 270px;
  overflow: hidden;
}
#leftBottomShowWindow3 .innerBox {
  display: flex;
  position: absolute;
  top: 0;
  left: -500px;
  height: 270px;
  width: 1350px;
}
#leftBottomShowWindow3 .innerBox div {
  position: absolute;
  top: 0px;
  width: 500px;
  height: 270px;
  z-index: 8;
  opacity: 1;
  transform: rotate(0deg);
  background: rgba(255, 255, 255, 0);
  border: 0px solid #2ed64a;
  border-radius: 0px;
  padding: 0px;
}
#leftBottomEchartsBox31 {
  left: 500px;
}
#leftBottomEchartsBox32 {
  left: 500px;
}
#leftBottomEchartsBox33 {
  left: 1000px;
}
.projectNumTable {
  width: 100%;
  height: 1.5rem;
  font-size: 16px;
  color: #fff;
}
#item93b724c0-3e03-11ec-a2e6-953464dcce14 {
  top: 100px;
}
.projectNumTable thead tr th:nth-child(1) {
  width: 60px;
}
.projectNumTable thead tr th:nth-child(2) {
  text-align: left;
}
.projectNumTable tbody tr td {
  text-align: center;
  height: 1.6rem;
}
.projectNumTable tbody tr td:nth-child(2) {
  text-align: left;
  height: 1.6rem;
}
.projectNumTable tbody tr {
  background: linear-gradient(to right, rgba(28, 103, 161, 1), rgba(28, 103, 161, 0.1));
}
.projectNumTable tbody tr:nth-child(2n) {
  background: linear-gradient(to right, rgba(4, 36, 94, 1), rgba(4, 36, 94, 0.1));
}
</style>
